module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"headline":"Цена билета изменилась, нажмите еще раз чтобы продолжить"},"en":{"headline":"Ticket price has changed, click again to continue"}}')
  delete Component.options._Ctor
}
